import { filterOptions } from "@src/helpers/constants";
import { Form, Select } from "antd";
import React, { useEffect, useMemo } from "react";

interface SubjectTypeProps {
  form: any;
}

const SubjectType: React.FC<SubjectTypeProps> = ({ form }) => {
  const gender = Form.useWatch("gender", form);

  // Dynamically compute allowed options
  const options = useMemo(() => {
    if (gender === "male" || gender === "other") {
      return filterOptions.subjectTypes.filter((opt) => opt.value !== "anc");
    }
    return filterOptions.subjectTypes;
  }, [gender]);

  useEffect(() => {
    const currentValue = form.getFieldValue("subjectType");
    // Reset only if current value is invalid for new gender
    if (currentValue && !options.some((opt) => opt.value === currentValue)) {
      form.setFieldsValue({ subjectType: undefined });
    }
  }, [gender, options, form]);

  return (
    <Form.Item
      name="subjectType"
      label="Type"
      rules={[{ required: true, message: "Please select the type" }]}
    >
      <Select placeholder="Select type" options={options} />
    </Form.Item>
  );
};

export default SubjectType;
